// Vocabulaire d'animation partagé — framer-motion.
// Une seule courbe, des durées courtes : le mouvement doit se sentir, pas se voir.
export const EASE = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
};

// Entrée sans translation — pour prefers-reduced-motion (useReducedMotion)
export const fadeUpReduced = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.25, ease: EASE } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.6, ease: EASE } },
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

// Révélation d'image par rideau — réservé aux grandes photos éditoriales.
export const clipReveal = {
  hidden: { clipPath: 'inset(0 0 100% 0)', opacity: 0.6 },
  show: {
    clipPath: 'inset(0 0 0% 0)',
    opacity: 1,
    transition: { duration: 0.9, ease: EASE },
  },
};

export const viewportOnce = { once: true, margin: '-80px' };
